import { memo } from 'react';

import DeveloperIconSVG from '@/assets/developer-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDeveloperIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DeveloperIconSVG} {...props} />;

export const DeveloperIcon = memo(IDeveloperIcon) as typeof IDeveloperIcon;
